// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import {
    getBeginWeeks, getConstraintKey,
    getConstraintTypeForOrderBundle,
    getEndWeeks, getOrderUsingBundleDropDown
} from '../../common/repositories';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import LabeledInput from '../../shared/components/labeled-input';
import LabeledReactSelect from '../../shared/components/options-drop-down/labeled-react-select';
import OptionsDropDown from '../../shared/components/options-drop-down';
import OrdersUsingBundlesTable from './components/orders-using-bundles-table';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formatGivenDate } from '../../shared/services/common-functions';
import { getOrderUsingBundles } from './repositories';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class OrdersUsingBundles extends Component {

    state = {
        types: [],
        keys: [],
        selectedKey: '',
        selectedType: '',
        results: null,
        beginWeeks: [],
        endWeeks: [],
        selectedBeginWeek: '',
        selectedEndWeek: '',
        bundles: [],
        selectedBundleOne: '',
        selectedBundleTwo: '',
        selectedBundleThree: '',
        selectedKeyObj: null,
        selectedBundleOneObj: null,
        selectedBundleTwoObj: null,
        selectedBundleThreeObj: null
    };

    componentDidMount = () => {

        this.props.increaseCounter();
        getConstraintTypeForOrderBundle( ).then( response => {

            this.setState( {
                types: response
            } );
            this.props.decreaseCounter();

        } );

    }

    handleTypeChange ( val ) {

        this.setState( {
            selectedType: val,
            selectedKey: '',
            selectedKeyObj: null,
            results: null,
            selectedBeginWeek: '',
            selectedEndWeek: ''

        }, () => {

            if ( this.state.selectedType !== '-1' ) {

                this.props.increaseCounter();
                getConstraintKey( this.state.selectedType ).then( response => {

                    const keys = response.map( item => ( {
                        label: item.id.trim(),
                        value: item.value.trim()
                    } ) );
                    this.setState( {
                        keys,
                        selectedKey: '',
                        results: null
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            }

        } );

    }

    handleKeyChange ( val ) {

        this.setState( {
            selectedKey: val.label,
            selectedKeyObj: val,
            results: null,
            selectedBeginWeek: '',
            selectedEndWeek: ''
        }, () => {

            if ( this.state.selectedKey !== '-1' ) {

                this.props.increaseCounter();
                getBeginWeeks( ).then( response => {

                    const bWeeks = response.map( i => {

                        const wk = formatGivenDate( i.beginWeek, 'YYYY-MM-DD' );
                        let wkn = wk;
                        if ( wk === '2000-01-01' ) wkn = 'Inventory';
                        if ( wk === '2000-02-01' ) wkn = 'Rework';
                        return { id: wk, value: wkn };

                    } );
                    this.setState( {
                        beginWeeks: bWeeks,
                        selectedEndWeek: '',
                        results: null
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            }

        } );

    }

    handleBeginWeekChange ( val ) {

        this.setState( {
            selectedBeginWeek: val,
            selectedEndWeek: '',
            results: null
        }, () => {

            if ( this.state.selectedBeginWeek !== '-1' ) {

                this.props.increaseCounter();
                getEndWeeks( this.state.selectedBeginWeek ).then( response => {

                    const eWeeks = response.map( i => {

                        const wk = formatGivenDate( i.endWeek, 'YYYY-MM-DD' );
                        let wkn = wk;
                        if ( wk === '2000-01-01' ) wkn = 'Inventory';
                        if ( wk === '2000-02-01' ) wkn = 'Rework';
                        return { id: wk, value: wkn };

                    } );
                    this.setState( {
                        endWeeks: eWeeks,
                        selectedEndWeek: '',
                        results: null
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            }

        } );

    }

    handleEndWeekChange ( val ) {

        this.setState( {
            selectedEndWeek: val
        }, () => {

            if ( this.state.selectedEndWeek !== '-1' ) {

                this.props.increaseCounter();
                getOrderUsingBundleDropDown( ).then( response => {

                    const bundleResp = response.map( item => ( {
                        label: item.id.trim(),
                        value: item.value.trim()
                    } ) );
                    this.setState( {
                        bundles: bundleResp,
                        selectedBundleOne: '',
                        selectedBundleTwo: '',
                        selectedBundleThree: '',
                        results: null,
                        selectedBundleOneObj: null,
                        selectedBundleTwoObj: null,
                        selectedBundleThreeObj: null
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            }

        } );

    }

    handleBundleOne ( val ) {

        this.setState( {
            selectedBundleOne: val.label === '-1' ? '' : val.label,
            selectedBundleOneObj: val
        } );

    }

    handleBundleTwo ( val ) {

        this.setState( {
            selectedBundleTwo: val.label === '-1' ? '' : val.label,
            selectedBundleTwoObj: val
        } );

    }

    handleBundleThree ( val ) {

        this.setState( {
            selectedBundleThree: val.label === '-1' ? '' : val.label,
            selectedBundleThreeObj: val
        } );

    }

    handleTextChange ( name, val ) {

        this.setState( {
            [`${name}`]: val.target.value === null ? this.state[`${name}`] : val.target.value
        }, () => {

            this.setDropDownValue( this.state[`${name}`], name );

        } );

    }

    handleOrderUsingBundles ( constraintType, constraintKey, beginWeek,
        endWeek, bundle1, bundle2, bundle3 ) {

        this.props.increaseCounter();
        const payload = {
            constraintType,
            constraintKey,
            beginWeek,
            endWeek,
            bundle1,
            bundle2,
            bundle3
        };
        getOrderUsingBundles( payload )
            .then( response => {

                this.setState( {
                    results: response
                } );

                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

    }

    setDropDownValue ( val, name ) {

        const bundleArray = this.state.bundles;
        const resp = bundleArray.map( value => {

            if ( value.label === val ) {

                return value;

            }
            return '';

        } );

        this.setState( {
            [`${name}Obj`]: resp
        } );

    }

    refresh = () => {

        if ( this.state.selectedType !== '-1' && this.state.selectedKey !== '-1'
            && this.state.selectedBeginWeek !== '-1' && this.state.selectedEndWeek !== '-1'
            && ( this.state.selectedBundleOne !== '-1' || this.state.selectedBundleTwo !== '-1'
            || this.state.selectedBundleThree !== '-1' ) ) {

            this.handleOrderUsingBundles( this.state.selectedType, this.state.selectedKey,
                this.state.selectedBeginWeek, this.state.selectedEndWeek,
                this.state.selectedBundleOne, this.state.selectedBundleTwo,
                this.state.selectedBundleThree );

        }

    }

    render () {

        const {
            selectedKey, selectedType, types, keys, selectedBeginWeek,
            selectedEndWeek, beginWeeks, endWeeks, results, bundles,
            selectedBundleOne, selectedBundleTwo, selectedBundleThree,
            selectedKeyObj, selectedBundleThreeObj,
            selectedBundleTwoObj, selectedBundleOneObj
        } = this.state;

        const mapResults = [];
        let k = 1;
        let orders = 0;
        if ( results !== null && results !== undefined ) {

            for ( let i = 0; i < results.length; i += 1 ) {

                const resultWithUnitName = results[i].orderUsingBundleDetails.map( order => (
                    { ...order, ...{ unitName: this.props.unit.name } } ) );
                orders += resultWithUnitName.length;
                const totalOrderForGrid = resultWithUnitName.length;
                resultWithUnitName[totalOrderForGrid] = { model: '0', message: `Total Orders: ${totalOrderForGrid}` };
                mapResults[k] = resultWithUnitName;
                mapResults[k].buildWeek = results[i].weekEnding;
                k += 1;

            }

        }

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                {/* <Breadcrumbs crumbs={crumbs} /> */}
                <header>
                    <h2 className="page-header">Orders Using Bundles</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-order-using-bundles-top-options">
                            <div className="select-options">
                                <OptionsDropDown
                                    className="atp-order-using-bundles-select"
                                    label="Type"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleTypeChange.bind( this )}
                                    optionDisplayAttributes={['value']}
                                    optionKey="id"
                                    options={types}
                                    placeholder="Select Type"
                                    selectedValue={selectedType}
                                />
                                {selectedType && selectedType !== '-1' && (
                                    <LabeledReactSelect
                                        className="atp-order-using-bundles-select"
                                        label="Key"
                                        isPlaceholderTranslated={true}
                                        onChange={this.handleKeyChange.bind( this )}
                                        // optionDisplayAttributes={['value']}
                                        // optionKey="id"
                                        options={keys}
                                        placeholder="Select Key"
                                        selectedValue={selectedKeyObj}
                                    />
                                )}
                                {selectedType && selectedKey && selectedKey !== '-1' && (
                                    <OptionsDropDown
                                        className="atp-order-using-bundles-select"
                                        label="Begin Week"
                                        isPlaceholderTranslated={true}
                                        onChange={this.handleBeginWeekChange.bind( this )}
                                        optionDisplayAttributes={['value']}
                                        optionKey="id"
                                        options={beginWeeks}
                                        placeholder="Select Begin Week"
                                        selectedValue={selectedBeginWeek}
                                    />
                                )}
                                {selectedType && selectedKey && selectedBeginWeek && selectedBeginWeek !== '-1' && (
                                    <OptionsDropDown
                                        className="atp-order-using-bundles-select"
                                        label="End Week"
                                        isPlaceholderTranslated={true}
                                        onChange={this.handleEndWeekChange.bind( this )}
                                        optionDisplayAttributes={['value']}
                                        optionKey="id"
                                        options={endWeeks}
                                        placeholder="Select End Week"
                                        selectedValue={selectedEndWeek}
                                    />
                                )}
                            </div>

                        </div>
                        <div className="atp-order-using-bundles-label-top-options">
                            {selectedType && selectedKey && selectedBeginWeek && selectedBeginWeek !== '-1' && selectedEndWeek && selectedEndWeek !== '-1' && (
                                <>
                                    <div className="atp-order-using-bundles-dropdown-label">
                                        <LabeledReactSelect
                                            className="atp-order-using-bundles-select-values"
                                            label="Bundle 1"
                                            isPlaceholderTranslated={true}
                                            onChange={this.handleBundleOne.bind( this )}
                                            // optionDisplayAttributes={['value']}
                                            // optionKey="id"
                                            options={bundles}
                                            placeholder="Bundle 1"
                                            selectedValue={selectedBundleOneObj}
                                        />
                                        <LabeledInput
                                            className="atp-order-using-bundles-label-input"
                                            name="selectedBundleOne"
                                            isEditable={true}
                                            label=" "
                                            maxLength={12}
                                            onChange={this.handleTextChange.bind( this, 'selectedBundleOne' )}
                                            value={selectedBundleOne}
                                            isRequired={false}
                                        />
                                    </div>
                                </>
                            )}

                            {selectedType && selectedKey && selectedBeginWeek && selectedBeginWeek !== '-1' && selectedEndWeek && selectedEndWeek !== '-1' && (
                                <>
                                    <div className="atp-order-using-bundles-dropdown-label">
                                        <LabeledReactSelect
                                            className="atp-order-using-bundles-select-values"
                                            label="Bundle 2"
                                            isPlaceholderTranslated={true}
                                            onChange={this.handleBundleTwo.bind( this )}
                                            // optionDisplayAttributes={['value']}
                                            // optionKey="id"
                                            options={bundles}
                                            placeholder="Bundle 2"
                                            selectedValue={selectedBundleTwoObj}
                                        />
                                        <LabeledInput
                                            className="atp-order-using-bundles-label-input"
                                            name="selectedBundleTwo"
                                            isEditable={true}
                                            label=" "
                                            maxLength={12}
                                            onChange={this.handleTextChange.bind( this, 'selectedBundleTwo' )}
                                            value={selectedBundleTwo}
                                            isRequired={false}
                                        />
                                    </div>
                                </>
                            )}

                            {selectedType && selectedKey && selectedBeginWeek && selectedBeginWeek !== '-1' && selectedEndWeek && selectedEndWeek !== '-1' && (
                                <>
                                    <div className="atp-order-using-bundles-dropdown-label">
                                        <LabeledReactSelect
                                            className="atp-order-using-bundles-select-values"
                                            label="Bundle 3"
                                            isPlaceholderTranslated={true}
                                            onChange={this.handleBundleThree.bind( this )}
                                            // optionDisplayAttributes={['value']}
                                            // optionKey="id"
                                            options={bundles}
                                            placeholder="Bundle 3"
                                            selectedValue={selectedBundleThreeObj}
                                        />

                                        <LabeledInput
                                            className="atp-order-using-bundles-label-input"
                                            name="selectedBundleThree"
                                            isEditable={true}
                                            label=" "
                                            maxLength={12}
                                            onChange={this.handleTextChange.bind( this, 'selectedBundleThree' )}
                                            value={selectedBundleThree}
                                            isRequired={false}
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                        <div className="export-report-button">
                            {selectedType && selectedKey && selectedBeginWeek &&
                            selectedEndWeek && (
                                <button className="primary-button" type="button" onClick={this.refresh.bind( this )}>
                                    <span> Create Report </span>
                                </button>
                            )}
                        </div>
                        <section className="messagecontainer">
                            {results !== null && selectedType && selectedKey &&
                            selectedBeginWeek && selectedEndWeek &&
                            ( selectedBundleOne || selectedBundleTwo || selectedBundleThree )
                            && (
                                <div className="displaydate"> Status as of {Date()}</div>
                            ) }
                            {results !== null && selectedType && selectedKey &&
                            selectedBeginWeek && selectedEndWeek &&
                            ( selectedBundleOne || selectedBundleTwo || selectedBundleThree )
                            && (
                                <div className="displayErrorMessage">Total Orders for Time Period: {orders}</div>
                            ) }
                        </section>
                        {results !== null && selectedType && selectedKey &&
                        selectedBeginWeek && selectedEndWeek &&
                        ( selectedBundleOne || selectedBundleTwo || selectedBundleThree )
                        && mapResults !== undefined && mapResults.map( ( item, index ) => (
                            <OrdersUsingBundlesTable
                                key={`bundles-table-${item.buildWeek}-${index}`}
                                results={item}
                                buildWeek={item.buildWeek}
                            />
                        ) ) }
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

OrdersUsingBundles.displayName = 'OrdersUsingBundles';
OrdersUsingBundles.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( OrdersUsingBundles ) );
